import Swal from "sweetalert2";

const ModalWarning = (message, title) =>
  Swal.fire({
    title: title ? title : "Are you sure?",
    text: message ? message : "Data has been saved",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Proceed",
    allowEscapeKey: false,
    allowOutsideClick: false,
    reverseButtons: true,
    didOpen: () => {
      const container = document.querySelector(".swal2-container");
      if (container) {
        container.style.zIndex = "9999";
      }
    },
  });

export default ModalWarning;
